<template>
  <examination-form
    v-if="initCustomer"
    :initExamination="initExamination"
    :initCustomer="initCustomer"
    :successMsg="t('created')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ExaminationForm from '@/views/examinations/ExaminationForm.vue'

import Examination, { type ExamType } from '@/models/customer/Examination'
import Customer from '@/models/customer/Customer'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-examination',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Examination was created successfully'
        },
        ar: {
          created: 'تم انشاءالفحص بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    ExaminationForm
  },
  data() {
    return {
      initExamination: new Examination(),
      initCustomer: null as Customer | null
    }
  },
  async mounted() {
    if (this.$route.query.customer_id) {
      this.initCustomer = await this.$http.get<Customer>(
        Customer.ENDPOINT + `/${this.$route.query.customer_id}`
      )
      this.initExamination.customerID = String(this.$route.query.customer_id)
    } else {
      this.initCustomer = new Customer()
    }
  },
  methods: {
    async submit(payload: Examination | FormData, print = false, examType?: ExamType) {
      try {
        const created = await this.$http.post<Examination>(Examination.ENDPOINT, payload)
        if (print) {
          await this.$router.replace({
            name: 'examination-receipt',
            params: { examination_id: created.id },
            query: examType ? { exam_type: examType } : undefined
          })
        } else {
          await this.$router.back()
        }
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
